import { apiClient } from "../../../api/client";
import * as ActionType from "./user.type";
import { setToast } from "../../../util/toast";

export const getUser = (start, limit) => async (dispatch) => {
  const res = await apiClient.get(`user/getUsers?start=${start}&limit=${limit}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_USER,
      payload: res.data?.users,
      totalUser: res.data?.totalUsers,
    });
  } else {
    console.error(res.message);
  }
};

export const userIsBlock = (user, block) => async (dispatch) => {
  const res = await apiClient.patch(`user/blockUnblock?userId=${user._id}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.BLOCK_UNBLOCK_USER,
      payload: { data: res.data.user, id: user._id },
    });
    setToast(
      "success",
      `${user.name} Is ${block === true ? "Blocked" : "Unblocked"} Successfully!`
    );
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const getUserProfile = (id) => async (dispatch) => {
  const res = await apiClient.get(`user/profile?userId=${id}`);
  if (res.ok) {
    dispatch({ type: ActionType.GET_USER_PROFILE, payload: res.data?.user });
  } else {
    console.error(res.message);
  }
};

export const getUserOrder =
  (userId, start, limit, status) => async (dispatch) => {
    const res = await apiClient.get(
      `order/ordersOfUser?userId=${userId}&start=${start}&limit=${limit}&status=${status}`
    );
    if (res.ok) {
      dispatch({
        type: ActionType.GET_USER_ORDER,
        payload: res.data?.orders || res.data,
        totalOrder: res.data?.totalOrders,
      });
    } else {
      console.error(res.message);
    }
  };
